class CartDiscounts extends HTMLElement {
  constructor() {
    super();
    this.settings();
    this.els();
    this.listeners();
  }

  settings() {
    this.sectionId = this.dataset.sectionId;
  }

  els() {
    this.cartDiscountErrorEl = this.querySelector('[ref="cartDiscountError"]');
    this.cartDiscountErrorDiscountCodeEl = this.querySelector('[ref="cartDiscountErrorDiscountCode"]');
    this.cartDiscountErrorShippingEl = this.querySelector('[ref="cartDiscountErrorShipping"]');
    this.formEl = this.querySelector('[data-cart-discounts-form]');
    this.inputEl = this.querySelector('[data-cart-discounts-input]');
  }

  listeners() {
    this.formEl.addEventListener('submit', e => {
      this.applyDiscount(e);
    });

    // remove codes
    this.addEventListener('click', e => {
      const removeEl = e.target.closest('[data-cart-discounts-remove]');
      if (!removeEl) return;
      const code = removeEl.dataset.cartDiscountsRemove;
      this.removeDiscount(e, code);
    });
  }

  loadingStateEnd() {
    this.formEl.classList.remove('loading');
    this.formEl.classList.remove('pointer-events');
  }

  loadingStateStart() {
    this.formEl.classList.add('loading');
    this.formEl.classList.add('pointer-events');
  }

  async applyDiscount(event) {
    event.preventDefault();

    this.loadingStateStart();

    const discountCodeValue = this.inputEl.value;

    try {
      const existingDiscounts = this.existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) return;

      this.cartDiscountErrorEl.classList.add('hidden');
      this.cartDiscountErrorDiscountCodeEl.classList.add('hidden');
      this.cartDiscountErrorShippingEl.classList.add('hidden');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: [...existingDiscounts, discountCodeValue].join(','),
          sections: [this.sectionId]
        }),
      })
      .then(response => response.json())
      .then(data => {
        const hasError = data.discount_codes.find(discount => {
          return discount.code === discountCodeValue && discount.applicable === false;
        });

        if (hasError) {
          this.handleDiscountError('discount_code');
        } else {
          window.updateCart();
        }

        this.loadingStateEnd();
      })
      .catch(error => {
        console.error('Error adding discount', error);
        this.loadingStateEnd();
      });
    } catch (error) {
      console.error('Error adding discount', error);
      this.loadingStateEnd();
    }
  }

  /**
   * Returns an array of existing discount codes.
   * @returns {string[]}
   */
  existingDiscounts() {
    const discountCodes = [];
    const discountPills = this.querySelectorAll('[data-cart-discounts-pill]');

    for (const pill of discountPills) {
      discountCodes.push(pill.dataset.discountCode);
    }

    return discountCodes;
  }

  handleDiscountError(type) {
    const targetEl = type === 'discount_code' ? this.cartDiscountErrorDiscountCodeEl : this.cartDiscountErrorShippingEl;
    this.cartDiscountErrorEl.classList.remove('hidden');
    targetEl.classList.remove('hidden');
  }

  removeDiscount = async (event, discountCode) => {
    event.preventDefault();
    event.stopPropagation();

    if (!discountCode) return;

    const existingDiscounts = this.existingDiscounts();
    const index = existingDiscounts.indexOf(discountCode);
    if (index === -1) return;

    this.loadingStateStart();

    existingDiscounts.splice(index, 1);

    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: existingDiscounts.join(','),
          sections: [this.sectionId]
        }),
      })
      .then(response => response.json())
      .then(data => {
        window.updateCart();
        this.loadingStateEnd();
      })
      .catch(error => {
        console.error('Error removing discount', error);
        this.loadingStateEnd();
      });
    } catch (error) {
      console.error('Error removing discount', error);
      this.loadingStateEnd();
    }
  };
}

if (!customElements.get('cart-discounts')) {
  customElements.define('cart-discounts', CartDiscounts);
}